'use strict';

import { EwSiteApp } from './ewsiteapp';

/**
 * Closes an address autocomplete suggestion list when the user clicks outside
 * of it or leaves it with the keyboard (Escape / Tab).
 *
 * Place it on the element that wraps BOTH the input and the suggestion list
 * (usually `.input-wrapper.ui-autocomplete`):
 *
 *   <div class="input-wrapper ui-autocomplete" address-suggest>
 *
 * By default it calls `clearAddressSugggests()` on the scope. Modules using a
 * different closing function can pass an expression:
 *
 *   <div class="input-wrapper ui-autocomplete" address-suggest="closeSuggest()">
 */
EwSiteApp.directive('addressSuggest', ['$document', '$parse', function ($document, $parse) {
	const KEY_TAB = 9;
	const KEY_ESCAPE = 27;

	return {
		restrict: 'A',
		link: function (scope, element, attrs) {
			var closeSuggest = attrs.addressSuggest
					? $parse(attrs.addressSuggest)
					: function (s) {
						if (angular.isFunction(s.clearAddressSugggests)) {
							s.clearAddressSugggests();
						}
					};

			function close() {
				scope.$applyAsync(function () {
					closeSuggest(scope);
				});
			}

			function onDocumentClick(event) {
				// clicks on the input itself or on a suggestion are handled by the module
				if (element[0].contains(event.target)) {
					return;
				}
				close();
			}

			function onKeydown(event) {
				if (event.keyCode === KEY_ESCAPE || event.keyCode === KEY_TAB) {
					close();
				}
			}

			// touchstart: iOS Safari does not always bubble `click` up to document
			$document.on('click touchstart', onDocumentClick);
			element.on('keydown', onKeydown);

			scope.$on('$destroy', function () {
				$document.off('click touchstart', onDocumentClick);
				element.off('keydown', onKeydown);
			});
		}
	};
}]);
